import React, {useState, useRef, useEffect} from 'react'
import {Logo, Menu, Music} from './components'
import {Route, Routes, useNavigate } from "react-router-dom"
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import {
  AfterMeadowPage,
  MeadowPage,
  StartPage,
  TrainPage,
  TrainStationPage,
  MapPage,
  BackpackPage,
  WaterfallPage,
  AfterWaterfallPage,
  TrailPage,
  AfterTrailPage,
  PeacsPage,
  AfterPeacsPage,
  CampPage,
  AfterCampPage,
  MountainPage,
  AfterMountainPage,
  FinalPage,
} from './pages'
import pageBg from './img/start-page-bg.webp'
import orientationBg from "./img/orientation-bg.webp";

function App () {
const musicPlayer = useRef(null)
  const [name, setName] = useState('')
  const [isLoaded, setIsLoaded] = useState(false)
  const [isPlayMusic, setIsPlayMusic] = useState(false)
  const [isCreenOrientation, setIsCreenOrientation] = useState(false)

    const prevLink = '/2023/'
      //const prevLink = ''



  const startPage = `${prevLink}`
  const trainPage = `${prevLink}train-page`
  const trainStationPage = `${prevLink}train-station-page`
  const meadowPage = `${prevLink}meadow-page`
  const afterMeadowGamePage = `${prevLink}after-meadow-game-page`
  const mapPage = `${prevLink}map-page`
  const backpackPage = `${prevLink}backpack-page`
  const waterfallPage = `${prevLink}waterfall-page`
  const afterWaterfallGamePage = `${prevLink}after-waterfall-game-page`
  const trailPage = `${prevLink}trail-page`
  const afterTrailGamePage = `${prevLink}after-trail-game-page`
  const peaksPage = `${prevLink}peaks-page`
  const afterPeaksGamePage = `${prevLink}after-peaks-game-page`
  const campPage = `${prevLink}camp-page`
  const afterCampGamePage = `${prevLink}after-camp-game-page`
  const mountainPage = `${prevLink}mountain-page`
  const afterMountainGamePage = `${prevLink}after-mountain-game-page`
  const finalPage = `${prevLink}final-page`

  // Пройденные странички
  const [isRouteTraveled , setIsRouteTraveled] = useState([
   /* afterMeadowGamePage,
    waterfallPage,
    afterWaterfallGamePage,
    trailPage,
    afterTrailGamePage,
    peaksPage,
    afterPeaksGamePage,*/
    //localStorage.getItem('isRouteTraveled')
  ])


  /*screen.addEventListener("orientationchange", function () {
		 console.log("The orientation of the screen is: " + screen.orientation);
	 })*/


  useEffect(() => {

    const handleResize = () => {
      setIsCreenOrientation((window.innerWidth > window.innerHeight) ? false : true);
    }

    window.addEventListener('orientationchange', handleResize);
    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize);
  }, []);

  useEffect(() => {
    if(isPlayMusic === true) {
      musicPlayer.current.audio.current.play();
      window.musicPlay = true;
    }
    if(isPlayMusic === false) {
      musicPlayer.current.audio.current.pause();
      window.musicPlay = false;
    }
  }, [isPlayMusic])

  const gameEnded = () => {
    if(isRouteTraveled.includes(afterMountainGamePage)) return 6
    if(isRouteTraveled.includes(afterCampGamePage)) return 5
    if(isRouteTraveled.includes(afterPeaksGamePage)) return 4
    if(isRouteTraveled.includes(afterTrailGamePage)) return 3
    if(isRouteTraveled.includes(afterWaterfallGamePage)) return 2
    if(isRouteTraveled.includes(afterMeadowGamePage)) return 1
    else {return 0}
  }

  //Навигация по приложению
  const navigate = useNavigate()
  const handleNextPage = (link) => {
    setIsLoaded(false)
    setIsRouteTraveled([...isRouteTraveled , link])
     /* localStorage.setItem('isRouteTraveled', isRouteTraveled)*/
    navigate(link)
  }

//console.log('localStorage', localStorage.getItem('isRouteTraveled'))

  //ADD FULLSCREEN ON ALL APP
  const handleFullScreen = useFullScreenHandle();

  return (
    <FullScreen handle={handleFullScreen}>
    <div className='root-wrap'>
      <img className='mainBg' src={pageBg} alt=""/>
      {isCreenOrientation &&
        <div className="orientationBg">
          <img className='mainBg' src={orientationBg} alt=""/>
        </div>
      }
      <img className='mainBg' src={pageBg} alt=""/>
      <Logo/>

      <Menu
        handleNextPage={handleNextPage}
        handleFullScreen={handleFullScreen}
        gameEnded={gameEnded}
        isRouteTraveled={isRouteTraveled}
        isPlayMusic={isPlayMusic}
        setIsPlayMusic={setIsPlayMusic}
        musicPlayer={musicPlayer}
        startPage={startPage}
        mapPage={mapPage}
        backpackPage={backpackPage}
        finalPage={finalPage}
      />

      <Music
        isPlayMusic={isPlayMusic}
        musicPlayer={musicPlayer}
        isRouteTraveled={isRouteTraveled}
        meadowPage={meadowPage}
        waterfallPage={waterfallPage}
        trailPage={trailPage}
        peaksPage={peaksPage}
        campPage={campPage}
        mountainPage={mountainPage}
        finalPage={finalPage}
      />

        <Routes>
        <Route path={startPage} element={
          <StartPage
            handleNextPage={handleNextPage}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
            setIsPlayMusic={setIsPlayMusic}
            trainPage={trainPage}
          />
        }/>

        <Route path={trainPage} element={
          <TrainPage
            handleNextPage={handleNextPage}
            name={name}
            setName={setName}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
            trainStationPage={trainStationPage}
          />
        }/>

          <Route path={trainStationPage} element={
            <TrainStationPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              meadowPage={meadowPage}
            />
          }/>

          <Route path={meadowPage} element={
            <MeadowPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              meadowPage={meadowPage}
              afterMeadowGamePage={afterMeadowGamePage}
            />
          }/>

          <Route path={afterMeadowGamePage} element={
            <AfterMeadowPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              mapPage={mapPage}
            />
          }/>

          <Route path={mapPage} element={
            <MapPage
              handleNextPage={handleNextPage}
              isRouteTraveled={isRouteTraveled}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              gameEnded={gameEnded}
              startPage={startPage}
              trainPage={trainPage}
              trainStationPage={trainStationPage}
              meadowPage={meadowPage}
              afterMeadowGamePage={afterMeadowGamePage}
              mapPage={mapPage}
              backpackPage={backpackPage}
              waterfallPage={waterfallPage}
              afterWaterfallGamePage={afterWaterfallGamePage}
              trailPage={trailPage}
              afterTrailGamePage={afterTrailGamePage}
              peaksPage={peaksPage}
              afterPeaksGamePage={afterPeaksGamePage}
              campPage={campPage}
              afterCampGamePage={afterCampGamePage}
              mountainPage={mountainPage}
              afterMountainGamePage={afterMountainGamePage}
              finalPage={finalPage}
            />
          }/>

          <Route path={backpackPage} element={
            <BackpackPage
              handleNextPage={handleNextPage}
              isRouteTraveled={isRouteTraveled}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              gameEnded={gameEnded}
              mapPage={mapPage}
              afterMeadowGamePage={afterMeadowGamePage}
              afterWaterfallGamePage={afterWaterfallGamePage}
              afterTrailGamePage={afterTrailGamePage}
              afterPeaksGamePage={afterPeaksGamePage}
              afterCampGamePage={afterCampGamePage}
              afterMountainGamePage={afterMountainGamePage}
            />
          }/>

          <Route path={waterfallPage} element={
            <WaterfallPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              waterfallPage={waterfallPage}
              afterWaterfallGamePage={afterWaterfallGamePage}
            />
          }/>

          <Route path={afterWaterfallGamePage} element={
            <AfterWaterfallPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              mapPage={mapPage}
            />
          }/>

          <Route path={trailPage} element={
            <TrailPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              trailPage={trailPage}
              afterTrailGamePage={afterTrailGamePage}
            />
          }/>

          <Route path={afterTrailGamePage} element={
            <AfterTrailPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              mapPage={mapPage}
            />
          }/>

          <Route path={peaksPage} element={
            <PeacsPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              peaksPage={peaksPage}
              afterPeaksGamePage={afterPeaksGamePage}
            />
          }/>

          <Route path={afterPeaksGamePage} element={
            <AfterPeacsPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              mapPage={mapPage}
            />
          }/>

          <Route path={campPage} element={
            <CampPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              campPage={campPage}
              afterCampGamePage={afterCampGamePage}
            />
          }/>

          <Route path={afterCampGamePage} element={
            <AfterCampPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              mapPage={mapPage}
            />
          }/>

          <Route path={mountainPage} element={
            <MountainPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              isRouteTraveled={isRouteTraveled}
              setIsRouteTraveled={setIsRouteTraveled}
              mountainPage={mountainPage}
              afterMountainGamePage={afterMountainGamePage}
            />
          }/>

          <Route path={afterMountainGamePage} element={
            <AfterMountainPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              setIsPlayMusic={setIsPlayMusic}
              finalPage={finalPage}
            />
          }/>

          <Route path={finalPage} element={
            <FinalPage
              handleNextPage={handleNextPage}
              name={name}
              setName={setName}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
              startPage={startPage}
            />
          }/>

        </Routes>
    </div>
    </FullScreen>
  )
}

export default App
